export const formatCurrency = (amount) => {
  // Remove any existing formatting and convert to number
  const number =
    typeof amount === 'string'
      ? Number(amount.replace(/[^0-9.-]+/g, ''))
      : Number(amount);

  // Return formatted string with Naira symbol
  return `₦${number.toLocaleString('en-NG')}`;
};
